import React, { useState } from 'react'

import { SourceTable } from 'types/GlobalSource'

import Box from 'components_new/atoms/Box'
import Divider from 'components_new/atoms/Divider'

import NavigationItem from 'components_new/molecules/NavigationItem'
import SearchField from 'components_new/molecules/SearchField'

interface SourceTablesColumnProps {
  activeTable: SourceTable | null
  onSelect: (id: string) => void
  tables: SourceTable[]
}

const SourceTablesColumn = (props: SourceTablesColumnProps) => {
  const { activeTable, onSelect, tables } = props

  const [searchQuery, setSearchQuery] = useState('')

  const visibleTables = tables
    .filter((table) =>
      table.attributes.name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name))

  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        display: 'flex',
        minHeight: 0,
        minWidth: 240,
        width: '20%'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          minHeight: 0
        }}
      >
        <Box sx={{ p: 1 }}>
          <SearchField
            onClear={() => setSearchQuery('')}
            onSearch={(value) => setSearchQuery(value)}
            placeholder="Sök bland tabeller..."
            size="small"
            value={searchQuery}
          />
        </Box>

        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 1 }}>
          {visibleTables.map((table) => (
            <NavigationItem
              active={table.id === activeTable?.id}
              item={{
                onClick: () => onSelect(table.id),
                title: table.attributes.name
              }}
              key={table.id}
            />
          ))}
        </Box>
      </Box>

      <Divider flexItem={true} orientation="vertical" />
    </Box>
  )
}

export default SourceTablesColumn
